/*
TPI - https://vimeo.com/1158215889?fl=ip&fe=ec -> https://player.vimeo.com/video/1158215889

Unsung Heroes - https://vimeo.com/1154069665?fl=ip&fe=ec

Christmas Village - https://vimeo.com/1154067049?fl=ip&fe=ec

2025 Mayor’s Masked Ball - https://vimeo.com/1154065478?fl=ip&fe=ec

2025 Ayla Awards - https://vimeo.com/1154064401?fl=ip&fe=ec

*/

const embedParams = "&title=0&byline=0&portrait=0";

const sourceMap = {
  tpi: `https://player.vimeo.com/video/1158215889?autoplay=1${embedParams}`,
  unsung: `https://player.vimeo.com/video/1154069665?autoplay=1${embedParams}`,
  christmas: `https://player.vimeo.com/video/1154067049?autoplay=1${embedParams}`,
  masked: `https://player.vimeo.com/video/1154065478?autoplay=1${embedParams}`,
  ayla: `https://player.vimeo.com/video/1154064401?autoplay=1${embedParams}`,
};

function isKeyofSourceMap(key?: string): key is keyof typeof sourceMap {
  return !!key && key in sourceMap;
}

const buttons = document.querySelectorAll("button");

buttons.forEach((button) => {
  button.addEventListener("click", (event) => {
    const key = (event.currentTarget as HTMLButtonElement).dataset.videoKey;
    if (isKeyofSourceMap(key)) replaceVideo(sourceMap[key]);
  });
});

function replaceVideo(nextSource: string) {
  const iframe = document.querySelector("iframe") as HTMLIFrameElement;
  iframe.src = nextSource;
}
